module.exports = "Please wait ...\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/feature/external/link/link.component.html
// module id = ./src/app/feature/external/link/link.component.html
// module chunks = main